import React from 'react';

import Icon from 'components/DesignSystem/Icon';
import { cssVar } from 'constants/theme';

import './index.scss';

export type OptionRowSelectionType = 'single' | 'multiple';

export interface OptionRowProps {
  label: string;
  selected: boolean;
  onSelect: () => void;
  selectionType?: OptionRowSelectionType;
  disabled?: boolean;
}

export default function OptionRow({
  label, selected, onSelect, selectionType = 'single', disabled = false,
}: OptionRowProps) {
  const isMultiple = selectionType === 'multiple';

  return (
    <button
      type="button"
      role={isMultiple ? 'checkbox' : 'radio'}
      aria-checked={selected}
      className={`control-panel-sheet-option-row${selected ? ' selected' : ''}`}
      onClick={onSelect}
      disabled={disabled}
    >
      <span className={`control-panel-sheet-option-row-indicator ${isMultiple ? 'checkbox' : 'radio'}`}>
        {isMultiple && selected && <Icon iconType="checkmark" color={cssVar('text-on-accent')} size="small" />}
        {!isMultiple && selected && <span className="control-panel-sheet-option-row-indicator-dot" />}
      </span>
      <span className="control-panel-sheet-option-row-label">{label}</span>
    </button>
  );
}
